import {APIURLSEGURIDAD} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fethValidarUsuario(usuario,password, modulo) {
    const body = { usuario, password, modulo }
    const url=APIURLSEGURIDAD + "/seguridad/validarusuarioexterno"
    const response = apiClient.post(url,body)
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;